import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TimeRecord } from '../../models/timerecord.model';

@Injectable({
  providedIn: 'root',
})
export class TimerecordsService {
  private baseUrl = 'api/timerecords';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  /**
   * Get time records for a week period
   * @param from Start date in YYYY-MM-DD format
   * @param to End date in YYYY-MM-DD format
   * @returns Observable array of TimeRecord objects
   */
  getWeek(from: moment.Moment, to: moment.Moment): Observable<TimeRecord[]> {
    return this.http.get<TimeRecord[]>(
      `${this.baseUrl}/${from.format('YYYY-MM-DD')}/${to.format('YYYY-MM-DD')}`
    );
  }

  /**
   * Update a time record
   */
  update(id: number, data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  /**
   * Insert a new time record
   */
  insert(data: any): Observable<any> {
    return this.http.post(this.baseUrl, data);
  }

  /**
   * Delete a time record
   */
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  updateNote(id: number, note: string | null): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/note`, { note });
  }
}
